module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2_1.09c6958a.png";